import { useState } from 'react'
import { Alert } from './Alert'
import { Button } from './Button'
import { refreshToLatest, useUpdateAvailable } from '../versionCheck'

interface UpdateBannerProps {
  /** Short, e.g. "New version": it shares one line with the button on a phone. */
  message: string
  /** Label of the button that loads it. */
  actionLabel: string
}

/**
 * A strip across the top of the app once the server is on a later version than
 * the running bundle. Renders nothing until then. Each app passes its own
 * translated strings, since the shared package carries no locale files.
 */
export function UpdateBanner({ message, actionLabel }: UpdateBannerProps) {
  const updateAvailable = useUpdateAvailable()
  const [refreshing, setRefreshing] = useState(false)

  if (!updateAvailable) return null

  return (
    <Alert
      color="primary"
      variant="flat"
      radius="none"
      title={message}
      // Short title, small type, and a button that never gives up its padding:
      // on a narrow phone the old sentence squeezed the button to its text.
      classNames={{
        base: 'shrink-0 items-center gap-2 py-2',
        mainWrapper: 'min-w-0',
        title: 'text-sm font-semibold',
      }}
      endContent={
        <Button
          size="sm"
          color="primary"
          className="shrink-0 px-4 font-semibold"
          isLoading={refreshing}
          onPress={() => {
            setRefreshing(true)
            void refreshToLatest()
          }}
        >
          {actionLabel}
        </Button>
      }
    />
  )
}
